import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/apiService";


export const GetAllPR_Nationality = createAsyncThunk(
  "dropdowns/GetAllPR_Nationality",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllPR_Nationality"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const PR_NationalityDropDown = createSlice({
  name: "PR_NationalityDropDown",
  initialState: {
    PR_NationalityDropDown: [],
    loadingPR_NationalityDropDown: false,
    errorPR_NationalityDropDown: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllPR_Nationality.pending, (state, action) => {
        state.loadingPR_NationalityDropDown = true;
        state.PR_NationalityDropDown = action.payload;
        state.errorPR_NationalityDropDown = null;
      })
      .addCase(GetAllPR_Nationality.fulfilled, (state, action) => {
        state.loadingPR_NationalityDropDown = false;
        state.PR_NationalityDropDown = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllPR_Nationality.rejected, (state, action) => {
        state.loadingPR_NationalityDropDown = false;
        state.errorPR_NationalityDropDown = action.payload;
      });
  },
});

export default PR_NationalityDropDown.reducer;
